import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import _ from 'lodash';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NewContactComponent } from '../../contact/new-contact/new-contact.component';
import { MessagesModule } from 'primeng/messages';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CustomerService } from '../../../../services/customer.service';
import { SharedModule } from '../../../../shared/shared.module';
import { LoaderComponent } from '../../../loader/loader.component';
import { customer } from '../../../../model/masters.model';
import { gridPageRequest, GSTTreatment } from '../../../../model/common/common.model';
import { ContactService } from '../../../../services/contact.service';
import { contact } from '../../../../model/contact/contact.model';
import { TermscodeLookupComponent } from '../../../Lookup/termscode-lookup/termscode-lookup.component';
import { GlAccountLookupComponent } from '../../../Lookup/glAccount-lookup/glAccount-lookup.component';

@Component({
  selector: 'app-new-customer',
  standalone: true,
  imports: [SharedModule, CommonModule, MessagesModule, LoaderComponent],
  providers: [DialogService, MessageService],
  templateUrl: './new-customer.component.html',
  styleUrl: './new-customer.component.scss'
})
export class NewCustomerComponent implements OnInit {

  @ViewChild('fileInput') fileInput!: ElementRef;

  submitted: boolean = false;
  loader: boolean = false;
  customerId: number | undefined;
  ref: DynamicDialogRef = new DynamicDialogRef;
  // previewImage: SafeUrl | undefined;
  saveImage: Blob | undefined;
  isEditMode: boolean = false;
  stateList: any[] = [];
  filterStates: any[] = [];
  ContactData: any[] = [];
  selectedcontact: any[] = [];
  isEdit: boolean = false;
  products: contact[] = [];
  contact: any;
  selectedContact: contact[] = [];
  contactHashTable: { [key: string]: contact } = {};
  selectedFile: File | null = null;
  previewImage: string | null = null;
  editCustomerData: any;
  gstTreatmentList: GSTTreatment[] = [];


  constructor(private customerService: CustomerService, private router: Router, private route: ActivatedRoute, public dialogService: DialogService,
    private messageService: MessageService, private sanitizer: DomSanitizer, private ContactServices: ContactService, private activatedRoute: ActivatedRoute, private confirmationService: ConfirmationService) { }

  // ngOnInit(): void {
  //   document.title = 'Create Customer';
  //   this.manualEntry();
  //   //this.patchCustomer();
  //   this.customerDetailsForm.controls.createdBy.setValue(localStorage.getItem('username'));
  //   this.route.queryParams.subscribe(param => {
  //     this.customerId = _.toNumber(param['customerId']);
  //     if (this.customerId) {
  //       this.customerService.getCustomerById(this.customerId).subscribe({
  //         next: data => {

  //         },
  //         error: error => {

  //         }
  //       })
  //     }
  //   });
  //   this.getStateList();
  //   this.getContact(this.pageRequest);

  //   //this.loadGSTTreatment();
  //   this.loadGSTTreatment(() => {
  //     this.patchCustomer();
  //   });

  //   this.customerDetailsForm.get('gstTreatment')?.valueChanges
  //     .subscribe((treatment: GSTTreatment | null) => {
  //       if (treatment) {
  //         this.onGSTTreatmentChange(treatment);
  //       }

  //     });

  // }

  ngOnInit(): void {

    document.title = 'Create Customer';

    this.manualEntry();

    this.customerDetailsForm.controls.createdBy
      .setValue(localStorage.getItem('username'));

    // ✅ Load master data
    this.getStateList();
    this.getContact(this.pageRequest);

    // ✅ Load GST first, then patch customer
    this.loadGSTTreatment(() => {
      this.patchCustomer();
    });


    this.filterStates = this.stateList.filter(x => x.stateCode !== '96');

    this.customerDetailsForm.get('gstTreatment')?.valueChanges
      .subscribe((treatment: GSTTreatment | null) => {

        if (!treatment) return;

        this.onGSTTreatmentChange(treatment);

        const isOverseas = treatment.isOverseas ?? false;

        if (isOverseas) {

          const other = this.stateList.find(x => x.stateCode === '96');

          this.filterStates = other ? [other] : [];

          this.customerDetailsForm.patchValue({
            address: {
              state: other?.stateName,
              stateCode: other?.stateCode,
              country: 'Other Country',
              zip: "999999"
            },
            //pos: '96'
          });

        } else {

          this.filterStates = this.stateList.filter(x => x.stateCode !== '96');
        }
      });

    this.customerDetailsForm.get('address.country')?.valueChanges
      .subscribe(country => {

        if (country?.toLowerCase() !== 'india') {

          const other = this.stateList.find(x => x.stateCode === '96');

          this.filterStates = other ? [other] : [];

          this.customerDetailsForm.patchValue({
            address: {
              state: other?.stateName,
              stateCode: '96',
              zip: "999999"
            },
            //pos: '96'
          });

        } else {

          this.filterStates = this.stateList.filter(x => x.stateCode !== '96');

          const stateCode = this.customerDetailsForm.get('address.stateCode')?.value;
          //this.customerDetailsForm.get('pos')?.setValue(stateCode);
        }
      });


    // this.customerDetailsForm.get('GSTIN')?.valueChanges
    //   .subscribe(() => {
    //     this.validateGSTINState();
    //   });
  }


  customerDetailsForm = new FormGroup({
    type: new FormControl('', Validators.required),
    //customerCode: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]),
    customerCode: new FormControl('', Validators.required),
    manualEntry: new FormControl(false),
    CustomerImage: new FormControl(),
    contact: new FormControl(""),
    customerName: new FormControl('', Validators.required),
    customerDescription: new FormControl(''),
    // isActive: new FormControl(true),
    isActive: new FormControl(true, Validators.requiredTrue),
    IsShipToCustomer: new FormControl(false),
    termsCode: new FormControl(),
    outstandingRec: new FormControl(),
    termsDescription: new FormControl(),
    glAccountCode: new FormControl(),
    creditLimit: new FormControl('0', [this.creditLimitValidator()]),
    noCreditCheck: new FormControl(true),
    noCreditLimit: new FormControl(true),
    address: new FormGroup({
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zip: new FormControl('', Validators.required),
      country: new FormControl('India', Validators.required),
      stateCode: new FormControl(''),
      CreatedBy: new FormControl(''),
    }),
    taxid: new FormControl(''),
    phone: new FormControl('', [Validators.pattern(/^[0-9]{10}$/)]),
    mobile: new FormControl('', [Validators.pattern(/^[0-9]{10}$/)]),
    email: new FormControl('', [Validators.email]),
    website: new FormControl(''),
    tags: new FormControl(''),
    createdBy: new FormControl(''),
    //GSTIN: new FormControl(''),
    GSTIN: new FormControl({ value: '', disabled: true }),
    //gstTreatment: new FormControl('', Validators.required),
    gstTreatment: new FormControl<GSTTreatment | null>(null, Validators.required),

  });
  customer: customer[] = [];


  get formControls() {
    return this.customerDetailsForm.controls;
  }

  save() {

    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Saved Successfully' })
  }

  cancel() {
    this.router.navigate(['/home/listCustomers']);
  }

  creditLimitValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const form = control?.parent;
      if (!form) {
        return null;
      }

      const noCreditLimit = form.get('noCreditLimit')?.value;
      const creditLimit = form.get('creditLimit')?.value;

      if (noCreditLimit === false && (creditLimit === null || creditLimit === '')) {
        return { creditLimitRequired: true };
      }

      if ((noCreditLimit === null || noCreditLimit === '') && (creditLimit === null || creditLimit === '')) {
        return { creditLimitRequired: true };
      }

      return null;
    };
  }

  validateForm() {
    let isValid = true;
    if (this.customerDetailsForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }



  // onFileSelected(event: any) {
  //   if(event){
  //     const file = event.target.files[0];
  //     this.saveImage = file;
  //     console.log(this.saveImage);
  //     this.previewImage = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
  //   }
  // }

  // deleteImage(){
  //   this.previewImage = undefined;
  // }


  onFileSelected(event: any): void {
    const file = event.target.files[0];
    const fileSizeKB: number = Math.round(file.size / 1024); // Convert bytes to KB
    if (fileSizeKB > 5000) {
      this.fileInput.nativeElement.value = '';
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select an image file up to 5MB in size.' })
      return;
    }
    if (!['image/jpeg', 'image/png'].includes(file.type)) {
      this.fileInput.nativeElement.value = '';
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a image.' })
      return;
    }
    if (file) {
      this.selectedFile = file;
      this.createImagePreview(file);
    }
  }


  createImagePreview(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.previewImage = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  show() {
    console.log(this.selectedFile);
  }

  // deleteImage(): void {
  //   if (this.selectedFile) {
  //     console.log('Deleting file:', this.selectedFile.name);
  //     this.selectedFile = null;
  //     this.previewImage = null; // Clear the image preview
  //     this.fileInput.nativeElement.value = ''; // Clear the file input value
  //   }
  // }

  deleteImage(): void {
    if (this.selectedFile || this.previewImage) {

      console.log('Deleting file:', this.selectedFile?.name || 'existing image');
      this.selectedFile = null;
      this.previewImage = null; // Clear the image preview
      this.customerDetailsForm.controls.CustomerImage.setValue(null);
      this.fileInput.nativeElement.value = '';
    }
  }
  validater() {
    const customerCodeControl = this.customerDetailsForm.get('customerCode');
    const mobileControl = this.customerDetailsForm.get('mobile');
    if (mobileControl?.invalid) {
      if (mobileControl.errors?.['pattern']) { }
      if (mobileControl.errors?.['maxlength']) { }
    }
    if (customerCodeControl?.invalid) {
      if (customerCodeControl.errors?.['required']) {
      }
      if (customerCodeControl.errors?.['pattern']) {
      }
    }
  }
  manualEntry() {
    const manualEntryValue = this.customerDetailsForm.controls.manualEntry.value;

    if (manualEntryValue === true) {
      this.customerDetailsForm.controls.customerCode.setValue('');
    } else {
      this.getCustomerCode();
    }

  }

  checkVendorCode() {
    if (!this.customerDetailsForm.controls.customerCode.value) {
      return;
    }
    if (!this.isEditMode) {
      this.customerService.checkCustomerCode(this.customerDetailsForm.controls.customerCode.value).subscribe(
        (data: any) => {
          if (data.success == true) {
            // console.log(data);
          } else {
            this.customerDetailsForm.controls.customerCode.setValue('');
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
            this.customerDetailsForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  // getStateList() {
  //   this.loader = true;
  //   this.customerService.getStateList().subscribe({
  //     next: (data: any) => {
  //       this.stateList = data;
  //       this.loader = false;
  //     },
  //     error: error => {
  //       console.log(error);
  //       this.loader = false;
  //     }
  //   });
  // }


  getStateList() {
  this.customerService.getStateList().subscribe({
    next: (data: any) => {
      this.stateList = (data ?? []).sort((a: any, b: any) =>
        (a.stateName ?? a.name ?? a.label ?? '').localeCompare(
          b.stateName ?? b.name ?? b.label ?? ''
        )
      );
    },
    error: error => {
      console.log(error);
    }
  });
}


  filterState(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.stateList as any[]).length; i++) {
      let state = (this.stateList as any[])[i];
      if (state.stateName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(state);
      }
    }

    this.filterStates = filtered;
  }

  // setState(event: any) {
  //   this.customerDetailsForm.controls.address.controls.state.setValue(event.value.stateName);
  //   this.customerDetailsForm.controls.GSTIN.setValue(event.value.stateCode);

  // }

  setState(event: any) {
    this.customerDetailsForm.patchValue({

      GSTIN: event.value.stateCode,
      address: {
        state: event.value.stateName,
        stateCode: event.value.stateCode,
        CreatedBy: localStorage.getItem('username'),
      }
    });
  }



  checkState() {
    const enteredState = this.customerDetailsForm.controls.address.controls.state.value;
    const validStates = this.stateList.map(state => state.stateName);

    if (validStates.includes(enteredState)) {
    } else {
      this.customerDetailsForm.controls.address.controls.state.setValue('');
    }
  }


  createCustomer(data: any) {
    this.submitted = true;

    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    this.loader = true;
    //  const customerData = this.customerDetailsForm.value;

    const formValue = this.customerDetailsForm.value;


    const customerData = {
      ...formValue,

      // convert object → code
      gstTreatmentCode: formValue.gstTreatment?.code,

      // optional: remove full object
      gstTreatment: undefined
    };

    //console.log(customerData);

    this.customerService.createCustomer(customerData).subscribe({
      next: (response: any) => {
        this.loader = false;

        if (response.success === true) {
          const customerId = response.id;
          this.saveContactData(customerId);

          if (this.selectedFile) {
            this.uploadCustomerImage(customerId);
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Customer created successfully.' });
            setTimeout(() => {
              this.router.navigate(['/home/listCustomers']);
            }, 1000);
          } else {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Customer created successfully.' });
            setTimeout(() => {
              this.router.navigate(['/home/listCustomers']);
            }, 1000);
          }
        } else {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: response.message });
        }
      },
      error: error => {
        this.loader = false;
        console.error('Error creating customer:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while creating the customer. Please try again later.' });
      }
    });
  }


  uploadCustomerImage(customerId: number) {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('image', this.selectedFile);

      this.customerService.uploadCustomerImage(customerId, formData).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Image uploaded successfully.' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Image upload failed.' });
          }
        },
      });
    }
  }

  saveContactData(customerId: any) {
    this.ContactData.forEach(contact => {
      contact.CustomerId = customerId;
      this.ContactServices.createContact(contact).subscribe({
        next: (response: any) => {
          console.log('Contact saved successfully:', response);
        },
        error: error => {
          console.error('Error saving contact:', error);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while saving contacts. Please try again later.' });
        }
      });
    });
  }

  showContact(customerId: number | undefined) {
    this.ContactServices.getContactByCustomer;
    this.ref = this.dialogService.open(NewContactComponent, {
      header: 'Create Contact',
      width: '80%',
      data: { customerId: customerId },
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.getContactData(data);
      }
    });
  }

  getCustomerCode() {
    this.loader = true;
    this.customerService.autogenerateCustomerCode().subscribe({
      next: (data: any) => {
        // const alphanumericCode = 'C';
        // const customerCode = alphanumericCode + data;
        this.customerDetailsForm.controls.customerCode.setValue(data.fullNumber);
        this.loader = false;
        this.customerId = data;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }

  patchCustomer() {
    this.activatedRoute.queryParams.subscribe((params: { [x: string]: any; }) => {
      this.customerId = params['CustomerId'];
      this.isEditMode = !!this.customerId;
      this.getContact(this.customerId);
      try {
        //this.editCustomerData = JSON.parse(params['customerData'])

        const data = params['customerData'];

        //console.log(this.editCustomerData);


        if (data) {
          this.editCustomerData = JSON.parse(data);
        }

        if (this.editCustomerData) {
          document.title = 'Update Customer ';
          //console.log('Fetching customer data for ID:', this.customerId);
          this.customerService.getCustomerById(this.editCustomerData).subscribe({
            next: (customer: any) => {
              if (customer) {
                this.isEditMode = true;
                //console.log('Customer data received:', customer);
                const selectedGST = this.gstTreatmentList
                  .find(x => x.code === customer.gstTreatment);

                this.customerDetailsForm.patchValue({
                  ...customer,
                  'contact': customer['ContactId'],
                  gstTreatment: selectedGST || null
                });
                if (customer.CustomerImage) {
                  this.setBase64Image(customer.CustomerImage);
                }
                if (selectedGST) {
                  this.onGSTTreatmentChange(selectedGST);
                }

              } else {
                console.log('No customer data found.');
              }
            },
            error: (error: any) => {
              console.error('Error fetching customer data:', error);
            }
          });
        } else {
          //console.log('Not in edit mode; no customer ID found.');
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  setBase64Image(imageBase64: string) {
    this.previewImage = `data:image/jpeg;base64,${imageBase64}`;
  }



  getContact(customerId: any) {
    this.ContactServices.getContactByCustomer(customerId).subscribe({
      next: (data: any) => {
        if (Array.isArray(data)) {
          data.forEach((item: any) => {
            item.contact = item.contactId;
          });
          this.ContactData = data;
        }
      },
      error: error => {
        console.error('Error fetching contact data:', error);
      }
    });
  }

  getContactData(savedDataString: any) {
    this.ContactData.push(savedDataString);
    const validRecords = this.ContactData.filter(record => typeof record === 'object');

    if (validRecords.length > 0 && typeof this.customerId !== 'undefined' && this.customerId !== 0) {
      validRecords.forEach(record => {
        record.CustomerId = this.customerId;
      });
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact Created Successfully.' });
      this.ContactData = validRecords;
    }
  }


  deleteContacts() {
    if (this.selectedContact && this.selectedContact.length > 0) {
      this.selectedContact.forEach(selected => {
        const index = this.ContactData.findIndex(contact => contact.contactId === selected.contactId);
        if (index !== -1) {
          this.ContactData.splice(index, 1);
        }
      });
      this.selectedContact = [];
      console.log("Selected contacts deleted successfully");
    } else {
      console.log("No contacts selected for deletion");
    }
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  // saveHashTableToSessionStorage(contacts: any[]) {
  //   const hashTableData = JSON.stringify(this.contactHashTable);
  //   sessionStorage.setItem('contactHashTable', hashTableData);
  // }

  // loadHashTableFromSessionStorage(contacts: any[]) {
  //   const hashTableData = sessionStorage.getItem('contactHashTable');
  //   if (hashTableData) {
  //     this.contactHashTable = JSON.parse(hashTableData);
  //   }
  // }

  EditContact() {
    if (this.selectedContact && this.selectedContact.length > 0) {
      const contactId = this.selectedContact[0].contactId;
      this.ref = this.dialogService.open(NewContactComponent, {
        header: 'Edit Contact',
        width: '80%',
        data: { contactId: contactId }
      });

      this.ref.onClose.subscribe((data: any) => {
        this.getContact(this.pageRequest);
      });
    }
    this.isEditMode = true;

  }

  getTermsCode() {
    this.ref = this.dialogService.open(TermscodeLookupComponent, {
      header: 'Terms Code',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.customerDetailsForm.patchValue({
          termsCode: data.termsCode,
          termsDescription: data.paymentTermsDescription
        })
      }
    })
  }


  getGLAccount() {
    this.ref = this.dialogService.open(GlAccountLookupComponent, {
      header: 'GL Account',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.customerDetailsForm.patchValue({
          glAccountCode: `${data.accountCode} - ${data.accountName}`
        })
      }
    })
  }

  onNoCreditLimitChange(): void {
    if (this.customerDetailsForm.controls['noCreditLimit'].value) {
      this.customerDetailsForm.controls['creditLimit'].setValue('');
      this.customerDetailsForm.controls['creditLimit'].disable();
    } else {
      this.customerDetailsForm.controls['creditLimit'].enable();
    }
  }

  onKeydown(event: KeyboardEvent) {
    //console.log('Keydown event:', event);

    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }
  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }

  // loadGSTTreatment() {
  //   this.customerService.getGSTTreatments().subscribe((res: any) => {
  //     this.gstTreatmentList = res;
  //   });
  // }


  loadGSTTreatment(callback?: () => void) {
    this.customerService.getGSTTreatments()
      .subscribe({
        next: (res: GSTTreatment[]) => {
          //console.log(res);

          this.gstTreatmentList = res;

          if (callback) {
            callback();
          }
        },
        error: (err) => {
          console.error('Error loading GST Treatments', err);
        }
      });
  }

  // onGSTTreatmentChange(treatment: GSTTreatment) {
  //   const gstinControl = this.customerDetailsForm.get('GSTIN');

  //   if (!treatment) {
  //     gstinControl?.clearValidators();
  //     gstinControl?.enable();
  //     gstinControl?.updateValueAndValidity();
  //     return;
  //   }

  //   if (treatment.allowsGSTIN) {
  //     gstinControl?.setValidators([
  //       Validators.required,
  //       Validators.pattern(/^[0-9A-Z]{15}$/) // GSTIN format
  //     ]);
  //     gstinControl?.enable();
  //   } else {
  //     gstinControl?.clearValidators();
  //     gstinControl?.setValue('');
  //     gstinControl?.disable();
  //   }

  //   gstinControl?.updateValueAndValidity();
  // }

  onGSTTreatmentChange(treatment: GSTTreatment | null) {
    const gstinControl = this.customerDetailsForm.get('GSTIN');
    if (!gstinControl) return;

    const allows = treatment?.allowsGSTIN ?? false;


    gstinControl.clearValidators();
    gstinControl.setValue(null);

    if (allows) {
      gstinControl.enable(); // enable first
      gstinControl.setValidators([
        Validators.required,
        Validators.pattern(/^[0-9A-Z]{15}$/)
        //Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/)
      ]);
    } else {
      gstinControl.disable(); // disable cleanly
    }

    gstinControl.updateValueAndValidity({ emitEvent: false });
  }


}
